import React from "react";
import { useNavigate } from "react-router-dom";
import { useT } from "./i18n";
import { renderRich } from "./RichText";
import "./styles/instruction_pages.css";

function EtudePage() {
  const navigate = useNavigate();
  const t = useT();

  const goToAfterCoach = () => {
    navigate("/after-coach");
  };

  return (
    <div className="page-container">
      <div>
        <h1 className="title">{t.etude.title}</h1>

        <div className="description">
          <section className="section">
            <h2>{t.etude.subtitle}</h2>
            <p>{renderRich(t.etude.intro1)}</p>
            <p>{renderRich(t.etude.intro2)}</p>
            <p>{renderRich(t.etude.intro3)}</p>
          </section>

          <section className="section">
            <h2>{t.etude.observeHeading}</h2>
            <ul>
              {t.etude.observe.map((item) => (
                <li key={item}>{renderRich(item)}</li>
              ))}
            </ul>
          </section>

          <section className="section">
            <p>{renderRich(t.etude.note)}</p>
          </section>

          <section className="section">
            <h2>{t.etude.scenariosHeading}</h2>
            <div className="table-wrapper">
              <table className="scenario-table">
                <thead>
                  <tr>
                    <th>{t.etude.scenariosColScenario}</th>
                    <th>{t.etude.scenariosColTask}</th>
                    <th>{t.etude.scenariosColPrompt}</th>
                  </tr>
                </thead>
                <tbody>
                  {t.etude.scenarios.map((row) => (
                    <tr key={row.name}>
                      <td
                        className="scenario-name"
                        data-label={t.etude.scenariosColScenario}
                      >
                        {row.name}
                      </td>
                      <td data-label={t.etude.scenariosColTask}>{row.task}</td>
                      <td
                        className="scenario-prompt"
                        data-label={t.etude.scenariosColPrompt}
                      >
                        {row.prompt}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        </div>

        <div className="button-container">
          <button className="button" onClick={goToAfterCoach}>
            {t.common.next}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EtudePage;
